import {http, onSuccess, onFail} from './http';

export const getEventTags = (eventKey) => {
    return http.get(`/api/cp/event/${eventKey}/tags`)
        .then(onSuccess, onFail);
};

export const createEventTag = (eventKey, payload) => {
    return http.post(`/api/cp/event/${eventKey}/tags`, payload)
        .then(onSuccess, onFail);
}

export const updateEventTag = (eventTag, payload) => {
    return http.post(`/api/cp/event/tags/${eventTag}`, payload)
        .then(onSuccess, onFail);
}

export const deleteEventTag = (eventTag) => {
    return http.delete(`/api/cp/event/tags/${eventTag}`)
        .then(onSuccess, onFail);
}
